/**
 * Business asset types for refinery model exploration
 * Provider-agnostic business asset type classification
 */
export enum AssetType {
  // Refinery facilities
  REFINERY = 'refinery',
  UNIT = 'unit',

  // Storage assets
  TANK = 'tank',

  // Flow assets
  PIPELINE = 'pipeline',
  FLOWMETER = 'flowmeter',

  // Physical assets
  EQUIPMENT = 'equipment',
  SENSOR = 'sensor',
  CONTROLLER = 'controller',

  // Process assets
  PROCESS = 'process',
  STREAM = 'stream',

  // Data assets
  DATABASE = 'database',
  TABLE = 'table',
  VIEW = 'view',
  COLUMN = 'column',

  // Documentation assets
  DOCUMENT = 'document',
  REPORT = 'report',

  // Fallback
  UNKNOWN = 'unknown',
}
